import $ from 'jquery';

function video() {

var videoOverlay = 		$('#video-overlay'),
	videoOverlayFrame = videoOverlay.find('iframe'),
	videoOverlayClose = videoOverlay.find('.video-close'),
	$body 			= $('body');

$('.video-play-btn').on('click', function() {
	var videoID = $(this).data('video');

	var iframeSrc = 'https://player.vimeo.com/video/' + videoID + '?autoplay=1&title=0&byline=0&portrait=0';

	videoOverlayFrame.attr('src', iframeSrc);

	videoOverlay.fadeIn();
	$body.addClass('no-scroll');
});

videoOverlayClose.on('click', function() {
	videoOverlay.fadeOut();
	videoOverlayFrame.attr('src', '');
	$body.removeClass('no-scroll');
});

}

export default video;
